"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectDisqualificationReason = exports.Verifications = exports.NdaType = exports.KindOfResearchTypes = exports.KindOfResearch = exports.RespondentStatus = exports.TaskParameters = exports.TaskStatus = exports.ResponseStatus = exports.ProjectRecruitingStatus = exports.GenderType = exports.ResearchConductType = exports.PricingChargeDetailType = exports.ParticipantAudienceType = exports.PricingCreditType = exports.MarketingPricingPlanType = exports.ParticipantType = exports.ProjectMatchingTriggerType = exports.Ethnicities = exports.Environment = exports.Countries = exports.Roles = exports.HttpVerbs = exports.enumHelper = exports.HttpVerb = void 0;
var _ = __importStar(require("lodash"));
// TODO provide through lookups API
var enums_stage_1 = require("./enums-stage");
Object.defineProperty(exports, "HttpVerb", { enumerable: true, get: function () { return enums_stage_1.HttpVerb; } });
var AttendanceStatus = {
    attended: 'ATTENDED',
    noshow: 'NOSHOW',
    invalidresponse: 'INVALIDRESPONSE',
    rejectedquality: 'REJECTEDQUALITY',
    cancelled: 'CANCELLED',
};
var enums = {
    Environment: {
        Production: 'PRODUCTION',
        Staging: 'STAGING',
        Qa: 'QA',
        Development: 'DEVELOPMENT',
        Local: 'LOCAL',
    },
    HttpVerb: enums_stage_1.HttpVerb,
    /**
     * @deprecated Use `HttpVerb` instead
     */
    HttpVerbs: enums_stage_1.HttpVerb,
    HttpStatusCode: enums_stage_1.HttpStatusCode,
    DefaultTimezone: enums_stage_1.DefaultTimezone,
    DefaultPicture: enums_stage_1.DefaultPicture,
    ReferralFee: enums_stage_1.ReferralFee,
    SignupReferralFee: enums_stage_1.SignupReferralFee,
    SignupReferralEarnedIncentiveThreshold: enums_stage_1.SignupReferralEarnedIncentiveThreshold,
    ProjectDelayVisibility: enums_stage_1.ProjectDelayVisibility,
    profileLockTimeInDays: enums_stage_1.profileLockTimeInDays,
    UserOmitFields: enums_stage_1.UserOmitFields,
    ReferralType: enums_stage_1.ReferralType,
    ProjectType: enums_stage_1.ProjectType,
    ResearcherReferralFee: enums_stage_1.ResearcherReferralFee,
    MinResearcherReferralSpend: enums_stage_1.MinResearcherReferralSpend,
    MaxProjectReferrals: enums_stage_1.MaxProjectReferrals,
    MinimumReferralFee: enums_stage_1.MinimumReferralFee,
    MinimumIncentiveForReferral: enums_stage_1.MinimumIncentiveForReferral,
    SupportPrice: enums_stage_1.SupportPrice,
    TransactionFee: enums_stage_1.TransactionFee,
    OversubscribedFactor: enums_stage_1.OversubscribedFactor,
    NewOrganizationServiceFee: enums_stage_1.NewOrganizationServiceFee,
    MaxOrganizationPaid: enums_stage_1.MaxOrganizationPaid,
    MaxPaidStudies: enums_stage_1.MaxPaidStudies,
    ScreenerCycle: {
        responseLimit: 3,
        approvedResponseLimit: 10,
        durationInSeconds: 86400,
    },
    RespondentScore: {
        survey: 1,
        qualified: 3,
        paid: 10,
        flag: -28,
        disqualify: -4,
    },
    CancelReason: {
        time: 'time',
        final: 'final',
    },
    CompanySize: [
        { name: 'Self Employed', code: 'selfemployed' },
        { name: '1 - 10', code: '1-10' },
        { name: '11 - 50', code: '11-50' },
        { name: '51 - 200', code: '51-200' },
        { name: '201 - 500', code: '201-500' },
        { name: '501 - 1,000', code: '501-1000' },
        { name: '1,001 - 5,000', code: '1001-5000' },
        { name: '5,001 - 10,000', code: '5001-10000' },
        { name: '10,000+', code: '10000+' },
    ],
    HouseholdIncome: [
        { name: '<$30,000', code: '<30000' },
        { name: '$30,000 - $39,999', code: '30000-39999' },
        { name: '$40,000 - $59,999', code: '40000-59999' },
        { name: '$60,000 - $79,999', code: '60000-79999' },
        { name: '$80,000 - $99,999', code: '80000-99999' },
        { name: '$100,000 - $149,999', code: '100000-149999' },
        { name: '$150,000 - $199,999', code: '150000-199999' },
        { name: '$200,000+', code: '200000+' },
    ],
    MatchingEmailEvents: [
        'sent',
        'delivered',
        'bounced',
        'opened',
        'clicked',
        'unsubscribed',
        'spam',
    ],
    DefaultCalendarSettings: [
        'minimumSchedulingNotice',
        'maxBookingsPerDay',
        'bufferBeforeEvent',
        'bufferAfterEvent',
    ],
    DisqualifyReason: {
        MISREPRESENTED: 'False or misleading information provided by Participant',
        CONTEXT: 'Not enough information about participant',
        SCREENER: 'Answers to screener questions not a match',
        OTHER: 'Other',
    },
    FlagReason: {
        MISREPRESENTED: 'Participant intentionally gave false or misleading information',
        INAPPROPRIATE: 'Inappropriate language or behavior',
        NOSHOW: 'Attended the project late or not at all',
        OTHER: 'Other',
    },
    ParticipantRatingStars: {
        minimum: 0,
        maximum: 5,
    },
    ParticipantRating: {
        MISREPRESENTED: {
            id: 'MISREPRESENTED',
            text: 'Honesty',
            description: 'Participant intentionally gave false or misleading information',
            type: 'negative',
            max: 3,
        },
        INAPPROPRIATE: {
            id: 'INAPPROPRIATE',
            text: 'Behavior',
            description: 'Participant exhibited inappropriate language or behavior',
            type: 'negative',
            max: 3,
        },
        NOSHOW: {
            id: 'NOSHOW',
            text: 'Punctuality',
            description: 'Participant attended the study late or not at all',
            type: 'negative',
            max: 4,
        },
        INARTICULATE: {
            id: 'INARTICULATE',
            text: 'Articulateness',
            description: 'Participant was difficult to follow or understand',
            type: 'negative',
            max: 4,
        },
        TECHNICALISSUES: {
            id: 'TECHNICALISSUES',
            text: 'Technical Preparedness',
            description: 'Participant fell short of hardware, software, or internet speed requirements',
            type: 'negative',
            max: 4,
        },
        OTHER: {
            id: 'OTHER',
            text: 'Other',
            description: 'Please Specify',
            type: 'negative',
            max: 4,
        },
        ARTICULATE: {
            id: 'ARTICULATE',
            text: 'Articulateness',
            description: 'Articulate, easy to follow and understand.',
            type: 'positive',
            max: 5,
            min: 5,
        },
        KNOWLEDGEABLE: {
            id: 'KNOWLEDGEABLE',
            text: 'Knowledgeable',
            description: 'Very knowledgeable on the given topic.',
            type: 'positive',
            max: 5,
            min: 5,
        },
        POLITE: {
            id: 'POLITE',
            text: 'Behavior',
            description: 'Polite, courteous and a pleasure to deal with.',
            type: 'positive',
            max: 5,
            min: 5,
        },
    },
    ProjectPricingTier: {
        low: { code: 'low', price: 10 },
        medium: { code: 'medium', price: 30 },
        normal: { code: 'normal', price: 50 },
        dynamic: { code: 'dynamic', price: null },
        free: { code: 'free', price: 0 },
    },
    NotificationTypes: {
        RespondentInvitationReminder: 'respondent-invitation-reminder',
        RespondentBookingReminder: 'respondent-booking-reminder',
        ResearcherProjectPublishReminder: 'researcher-project-publish-reminder',
        ResearcherProjectExpiredNotification: 'researcher-project-expired-notification',
    },
    QuestionTypes: {
        MultipleChoicesSingle: {
            id: 1,
            text: 'Multiple choice',
            answerValues: [
                { id: 1, text: 'Qualify' },
                { id: 2, text: 'Disqualify' },
            ],
        },
        OpenEnded: { id: 2, text: 'Comment box' },
        MultipleChoicesMany: {
            id: 3,
            text: 'Checkboxes',
            answerValues: [
                { id: 1, text: 'May Select' },
                { id: 2, text: 'Must Select' },
                { id: 3, text: 'Disqualify' },
            ],
        },
        OpenEndedShortAnswer: { id: 4, text: 'Single-line text box' },
        NumericOpenEnded: { id: 5, text: 'Numeric box' },
        SliderScale: { id: 6, text: 'Slider' },
    },
    Roles: {
        superadmin: 'superadmin',
        admin: 'admin',
        researcher: 'researcher',
        respondent: 'respondent',
        paymentManager: 'paymentmanager',
        userManager: 'usermanager',
        /**
         * @deprecated
         */
        // TODO remove when promotionManager abilities have been completely removed
        promotionManager: 'promotionManager',
    },
    CreditSource: {
        admin: 'admin',
        promotion: 'promotion',
        organization: 'organization',
    },
    PaymentType: {
        payAsYouGo: 'payg',
        credit: 'credit',
    },
    ProjectStatus: {
        draft: 'DRAFT',
        approved: 'APPROVED',
        underReview: 'UNDERREVIEW',
        partiallyPaid: 'PARTIALLYPAID',
        paid: 'PAID',
        published: 'PUBLISHED',
        archived: 'ARCHIVED',
    },
    ProjectRecruitingStatus: {
        recruiting: 'RECRUITING',
        recruited: 'RECRUITED',
        paused: 'PAUSED',
    },
    RespondentIsNewHours: 120,
    RespondentStatus: {
        approved: 'APPROVED',
        verified: 'VERIFIED',
        pending: 'PENDING',
        rejected: 'REJECTED',
    },
    AttendanceStatus: AttendanceStatus,
    ResponseStatus: __assign(__assign({}, AttendanceStatus), { draft: 'DRAFT', pending: 'PENDING', invited: 'INVITED', scheduled: 'SCHEDULED', paid: 'PAID' }),
    TaskStatus: {
        pending: 'pending',
        complete: 'complete',
    },
    ProfileRiskLevel: {
        REJECTED: 'rejected',
        APPROVED: 'approved',
        QUESTIONED: 'questioned',
    },
    ResponseVisibility: {
        rejectedProfile: {
            name: 'DISMISSED: Profile Rejected',
            status: 'DISMISSED',
            code: 'REJECTED_PROFILE',
        },
        rejectedProfileTwilio: {
            name: 'DISMISSED: Profile Rejected',
            status: 'DISMISSED',
            code: 'REJECTED_PROFILE_TWILIO',
        },
        rejectedProfileRiskLevel: {
            name: 'DISMISSED: Profile Rejected',
            status: 'DISMISSED',
            code: 'REJECTED_PROFILE_RISK_LEVEL',
        },
        marketplacePaid: {
            name: 'DISMISSED: Profile Rejected',
            status: 'DISMISSED',
            code: 'MARKETPLACE_PAID',
        },
        flagged: {
            name: 'DISMISSED: Flagged',
            status: 'DISMISSED',
            code: 'FLAGGED',
        },
        dataAutomated: {
            name: 'DISMISSED: Auto Rejected',
            status: 'DISMISSED',
            code: 'DATA_AUTOMATED',
        },
        pendingProfile: {
            name: 'ONHOLD: Profile Incomplete',
            status: 'ONHOLD',
            code: 'PENDING_PROFILE',
        },
        draft: { name: 'DRAFT', status: 'DRAFT', code: 'DRAFT' },
        visible: { name: 'VISIBLE', status: 'VISIBLE', code: 'OK' },
    },
    PaymentItemType: {
        fee: 'fee',
        transactionFee: 'transactionFee',
        incentive: 'incentive',
        support: 'support',
        credit: 'credit',
    },
    TransferCreditTypes: {
        recruitment: 'Recruitment',
        incentive: 'Incentive',
    },
    PaymentStatus: {
        pending: 'PENDING',
        paid: 'PAID',
        voided: 'VOIDED',
        refunded: 'REFUNDED',
        failed: 'FAILED',
        complete: 'COMPLETE',
    },
    BatchStatus: {
        pending: 'PENDING',
        completed: 'COMPLETED',
        manual: 'MANUAL',
        rejected: 'REJECTED',
    },
    RelationshipStatuses: [
        { name: 'Married', code: 'married' },
        { name: 'Widowed', code: 'widowed' },
        { name: 'Divorced', code: 'divorced' },
        { name: 'Separated', code: 'separated' },
        {
            name: 'In a domestic partnership or civil union',
            code: 'domesticpartnership',
        },
        {
            name: 'Single, but cohabiting with a significant other',
            code: 'singlewithasignificantother',
        },
        { name: 'Single, never married', code: 'single' },
    ],
    Ethnicities: [
        {
            name: 'American Indian / Alaskan Native',
            code: 'americanindianalaskannative',
        },
        { name: 'Hispanic or Latino', code: 'hispaniclatino' },
        { name: 'Black or African American', code: 'blackorafricanamerican' },
        { name: 'Asian or Pacific Islander', code: 'asianpacificislander' },
        { name: 'White / Caucasian', code: 'whitecaucasian' },
        { name: 'Middle Eastern', code: 'middleeastern' },
        { name: 'Mixed Ethnicity', code: 'multipleethnicity' },
        { name: 'Prefer not to disclose', code: 'prefernotdisclose' },
    ],
    // Matches CoreAPI exported enum
    GenderType: {
        MALE: 'male',
        FEMALE: 'female',
        OTHER: 'other',
        /** Legacy: Not used by Profiles and Projects, should specify undefined */
        NA: 'N/A',
    },
    Genders: [
        { name: 'Male', code: 'male' },
        { name: 'Female', code: 'female' },
        { name: 'Other', code: 'other' },
    ],
    KindOfResearch: {
        'One-on-One': { code: 1, remote: true, inPerson: true },
        'Focus Group': { code: 2, remote: true, inPerson: true },
        'Multi Day Study': { code: 3, remote: false, inPerson: false },
        'Unmoderated Study': { code: 4, remote: true, inPerson: false },
        'Phone Interview': { code: 5, remote: false, inPerson: false },
        'Usability Testing': { code: 6, remote: false, inPerson: false },
        'In Respondent Home': { code: 8, remote: false, inPerson: true },
        Survey: { code: 9, remote: true, inPerson: false },
        'Diary Study': { code: 10, remote: true, inPerson: false },
        'In Respondent Office': { code: 11, remote: false, inPerson: true },
    },
    // TODO created lookup for KindOfResearchTypes by copying KindOfResearch
    // and making it a list of objects instead of a map.
    // TODO extend to include remote and inPerson into the objects, but
    // right now it's not a requirement
    // TODO KindOfResearchTypes should be ResearchTypes, but that's already
    // taken... so renaming these appropriately should happen at some point
    KindOfResearchTypes: [
        { code: 1, name: 'One-on-One', methodologyType: 'oneOnOne' },
        { code: 2, name: 'Focus Group', methodologyType: 'focusGroup' },
        { code: 3, name: 'Multi Day Study', methodologyType: null },
        { code: 4, name: 'Unmoderated Study', methodologyType: 'unmoderatedStudy' },
        { code: 5, name: 'Phone Interview', methodologyType: null },
        { code: 6, name: 'Usability Testing', methodologyType: null },
        {
            code: 8,
            name: 'In Respondent Home',
            methodologyType: 'inRespondentHome',
        },
        { code: 9, name: 'Survey', methodologyType: 'survey' },
        { code: 10, name: 'Diary Study', methodologyType: 'diaryStudy' },
        {
            code: 11,
            name: 'In Respondent Office',
            methodologyType: 'inRespondentOffice',
        },
    ],
    EmploymentStatuses: [
        { name: 'Self Employed / Owner', code: 'owner' },
        { name: 'Employed, working full-time', code: 'employedfulltime' },
        { name: 'Employed, working part-time', code: 'employedparttime' },
        {
            name: 'Not employed, looking for work',
            code: 'unemployedlookingforwork',
        },
        { name: 'Not employed, NOT looking for work', code: 'unemployed' },
        { name: 'Retired', code: 'retired' },
        { name: 'Disabled, not able to work', code: 'disabled' },
    ],
    SeniorityLevels: [
        { name: 'Entry Level', code: 'entrylevel' },
        { name: 'Partner', code: 'partner' },
        { name: 'Senior', code: 'senior' },
        { name: 'Manager', code: 'manager' },
        { name: 'Director', code: 'director' },
        { name: 'Vice President (VP)', code: 'vicepresident' },
        { name: 'Chief X Officer (CxO)', code: 'chiefofficer' },
        { name: 'Training', code: 'training' },
        { name: 'Unpaid', code: 'unpaid' },
        { name: 'Student', code: 'student' },
    ],
    ProjectMatchingTriggerType: {
        SCORE: 'score',
        RESCORE: 'rescore',
        RETRIGGER_PROJECT: 'retrigger-project',
    },
    SupportedIntegrations: {
        lookback: { name: 'Lookback', type: 'lookback' },
        surveyMonkey: { name: 'SurveyMonkey', type: 'surveymonkey' },
        customURL: { name: 'Custom URL', type: 'custom_url' },
    },
    TaskParameters: [
        { name: 'Project ID', type: 'projectId', default: 'project_id' },
        {
            name: 'Participant ID',
            type: 'participantId',
            default: 'participant_id',
        },
    ],
    EducationLevels: [
        { name: 'Some High School', code: 'somehighschool' },
        { name: 'High School Graduate', code: 'highschoolgraduate' },
        { name: 'Some College, no degree', code: 'somecollegenodegree' },
        {
            name: 'Trade/Technical/Vocational training',
            code: 'tradetechnicalvocationaltraining',
        },
        { name: 'Associate Degree', code: 'associatedegree' },
        { name: "Bachelor's Degree", code: 'bachelordegree' },
        { name: "Master's Degree", code: 'masterdegree' },
        { name: 'Doctorate Degree', code: 'doctoratedegree' },
    ],
    ResearchTypes: [
        { code: 1, name: 'In-Person' },
        { code: 2, name: 'Remote' },
    ],
    AudienceTypes: [
        { code: 1, name: 'Industry Professionals' },
        { code: 2, name: 'General Population' },
    ],
    // Matches CoreAPI exported enum
    ResearchConductType: {
        IN_PERSON: 1,
        REMOTE: 2,
    },
    // Matches CoreAPI exported enum
    ParticipantType: {
        B2C: 'b2c',
        B2B: 'b2b',
    },
    // Matches CoreAPI exported enum
    /**
     * @description
     * Type safe mapping of AudienctTypes to ParticipantType
     * for contextual comparisons.
     *
     * @see AudienceTypes for reference
     */
    ParticipantAudienceType: {
        B2B: 1,
        B2C: 2, // = 'General Population'
    },
    /**
     * @description
     * Lookup for ParticipantType, and allows for AudienceType
     * to ParticipantType conversions and contextual comparisons.
     *
     * @see AudienceTypes for reference
     */
    // TODO make this work but for now hardcode below due to build errors
    // ParticipantTypes: [
    //   {
    //     code: ParticipantAudienceType.B2B,
    //     name: 'B2B',
    //     type: ParticipantType.B2B,
    //   },
    //   {
    //     code: ParticipantAudienceType.B2C,
    //     name: 'B2C',
    //     type: ParticipantType.B2C,
    //   },
    // ],
    ParticipantTypes: [
        { code: 1, name: 'B2B', type: 'b2b' },
        { code: 2, name: 'B2C', type: 'b2c' },
    ],
    MarketingPricingPlanType: {
        PAYG: 'payg',
        BASIC: 'basic',
        ADVANCED: 'advanced',
        CUSTOM: 'custom',
        PAYG_V3: 'payg_v3',
        BASIC_V3: 'basic_v3',
        ADVANCED_V3: 'advanced_v3',
        CUSTOM_V3: 'custom_v3',
    },
    // TODO considered a Lookup and should be split out appropriately, but
    // for v1 this is sufficient to have everything centralized
    MarketingPricingPlanTypes: [
        {
            // TODO errrr doesn't work and causes build to fail
            // code: enums.MarketingPricingPlanType.PAYG,
            code: 'payg',
            name: 'Pay as you go',
        },
        {
            // TODO errrr doesn't work and causes build to fail
            // code: enums.MarketingPricingPlanType.BASIC,
            code: 'basic',
            name: 'Basic',
        },
        {
            // TODO errrr doesn't work and causes build to fail
            // code: enums.MarketingPricingPlanType.ADVANCED,
            code: 'advanced',
            name: 'Advanced',
        },
        {
            // TODO errrr doesn't work and causes build to fail
            // code: enums.MarketingPricingPlanType.CUSTOM,
            code: 'custom',
            name: 'Enterprise',
        },
        {
            // TODO errrr doesn't work and causes build to fail
            // code: enums.MarketingPricingPlanType.PAYG,
            code: 'payg_v3',
            name: 'Pay as you go',
        },
        {
            // TODO errrr doesn't work and causes build to fail
            // code: enums.MarketingPricingPlanType.BASIC,
            code: 'basic_v3',
            name: 'Basic',
        },
        {
            // TODO errrr doesn't work and causes build to fail
            // code: enums.MarketingPricingPlanType.ADVANCED,
            code: 'advanced_v3',
            name: 'Advanced',
        },
        {
            // TODO errrr doesn't work and causes build to fail
            // code: enums.MarketingPricingPlanType.CUSTOM,
            code: 'custom_v3',
            name: 'Enterprise',
        },
    ],
    PricingCreditType: {
        CREDIT: 'credit',
        INCENTIVE: 'incentive',
    },
    PricingChargeDetailType: {
        PLAN: 'plan',
        CREDIT: 'credit',
        INCENTIVE: 'incentive',
        PAUSED: 'paused',
        MERCHANT_FEE: 'merchantFee',
    },
    Countries: enums_stage_1.Countries,
    maxTipPercentageOfIncentive: enums_stage_1.maxTipPercentageOfIncentive,
    increasedMaxTipPercentage: enums_stage_1.increasedMaxTipPercentage,
    ZoomConnectionStatus: {
        CONNECTED: 'CONNECTED',
        DISCONNECTED: 'DISCONNECTED',
        NEEDS_RECONNECTION: 'NEEDS_RECONNECTION',
    },
    ProviderType: {
        GOOGLE: 'google',
        OUTLOOK: 'outlook',
        FACEBOOK: 'facebook',
        LINKEDIN: 'linkedin',
        ZOOM: 'zoom',
    },
    NdaType: {
        NONE: 'none',
        LINK: 'link',
        FILE: 'file',
    },
    Verifications: {
        PLAID: 'plaid',
    },
    ProjectDisqualificationReason: {
        MUST_COMPLETE_PROFILE: 'mustCompleteProfile',
        WORK_EMAIL_REQUIRED: 'workEmailRequired',
        INCORRECT_DEMOGRAPHICS: 'incorrectDemographics',
    },
    enumHelper: {
        getQuestionText: function (questionTypeId) {
            if (questionTypeId === enums.QuestionTypes.MultipleChoicesMany.id) {
                return enums.QuestionTypes.MultipleChoicesMany.text;
            }
            if (questionTypeId === enums.QuestionTypes.MultipleChoicesSingle.id) {
                return enums.QuestionTypes.MultipleChoicesSingle.text;
            }
            if (questionTypeId === enums.QuestionTypes.OpenEnded.id) {
                return enums.QuestionTypes.OpenEnded.text;
            }
            return null;
        },
        getAnswerValueText: function (questionTypeId, answerValueId) {
            if (questionTypeId === enums.QuestionTypes.MultipleChoicesMany.id) {
                if (enums.QuestionTypes.MultipleChoicesMany.answerValues[0].id ===
                    answerValueId) {
                    return enums.QuestionTypes.MultipleChoicesMany.answerValues[0].text;
                }
                if (enums.QuestionTypes.MultipleChoicesMany.answerValues[1].id ===
                    answerValueId) {
                    return enums.QuestionTypes.MultipleChoicesMany.answerValues[1].text;
                }
                if (enums.QuestionTypes.MultipleChoicesMany.answerValues[2].id ===
                    answerValueId) {
                    return enums.QuestionTypes.MultipleChoicesMany.answerValues[2].text;
                }
            }
            if (questionTypeId === enums.QuestionTypes.MultipleChoicesSingle.id) {
                if (enums.QuestionTypes.MultipleChoicesSingle.answerValues[0].id ===
                    answerValueId) {
                    return enums.QuestionTypes.MultipleChoicesSingle.answerValues[0].text;
                }
                if (enums.QuestionTypes.MultipleChoicesSingle.answerValues[1].id ===
                    answerValueId) {
                    return enums.QuestionTypes.MultipleChoicesSingle.answerValues[1].text;
                }
            }
            return null;
        },
        // TODO separate out into lookupsService similar to the one created in the client
        getEnumValue: function (enumType, key) {
            var _a;
            if (enumType === 'companySize') {
                var index = _.findIndex(enums.CompanySize, function (item) { return item.code === key; });
                if (index > -1) {
                    return enums.CompanySize[index].name;
                }
            }
            if (enumType === 'householdIncome') {
                var index = _.findIndex(enums.HouseholdIncome, function (item) { return item.code === key; });
                if (index > -1) {
                    return enums.HouseholdIncome[index].name;
                }
            }
            if (enumType === 'relationshipStatus') {
                var index = _.findIndex(enums.RelationshipStatuses, function (item) { return item.code === key; });
                if (index > -1) {
                    return enums.RelationshipStatuses[index].name;
                }
            }
            if (enumType === 'ethnicity') {
                var index = _.findIndex(enums.Ethnicities, function (item) { return item.code === key; });
                if (index > -1) {
                    return enums.Ethnicities[index].name;
                }
            }
            if (enumType === 'gender') {
                var index = _.findIndex(enums.Genders, function (item) { return item.code === key; });
                if (index > -1) {
                    return enums.Genders[index].name;
                }
            }
            if (enumType === 'researchtypes') {
                var index = _.findIndex(enums.ResearchTypes, function (item) { return item.code === key; });
                if (index > -1) {
                    return enums.ResearchTypes[index].name;
                }
            }
            if (enumType === 'audiencetypes') {
                var index = _.findIndex(enums.AudienceTypes, function (item) { return item.code === key; });
                if (index > -1) {
                    return enums.AudienceTypes[index].name;
                }
            }
            // TODO clean up the other methods in this file since the predicate is the same
            // so all the repetition is ridiculous !o.O!
            if (enumType === 'participantTypes') {
                return (_a = enums.ParticipantTypes.find(function (item) { return item.code === key; })) !== null && _a !== void 0 ? _a : null;
            }
            var kindOfResearchName = _.findKey(enums.KindOfResearch, function (v) { return v.code === key; });
            if (enumType === 'kindofresearch' && Boolean(kindOfResearchName)) {
                return kindOfResearchName;
            }
            if (enumType === 'employmentStatus') {
                var index = _.findIndex(enums.EmploymentStatuses, function (item) { return item.code === key; });
                if (index > -1) {
                    return enums.EmploymentStatuses[index].name;
                }
            }
            if (enumType === 'seniorityLevel') {
                var index = _.findIndex(enums.SeniorityLevels, function (item) { return item.code === key; });
                if (index > -1) {
                    return enums.SeniorityLevels[index].name;
                }
            }
            if (enumType === 'educationLevel') {
                var index = _.findIndex(enums.EducationLevels, function (item) { return item.code === key; });
                if (index > -1) {
                    return enums.EducationLevels[index].name;
                }
            }
            if (enumType === 'paymentType') {
                if (key === enums.PaymentType.payAsYouGo) {
                    return 'Credit Card';
                }
                if (key === enums.PaymentType.credit) {
                    return 'Recruiting Balance';
                }
            }
            return '';
        },
        getCountry: function (code) {
            if (code === 'all') {
                return { code: 'all', name: 'All' };
            }
            return _.find(enums.Countries, function (c) { return c.code === code; });
        },
        isQuantitativeStudy: function (kindOfResearch) {
            return (kindOfResearch === 9 || kindOfResearch === 4 || kindOfResearch === 10);
        },
        isRemote: function (researchConductType) {
            return researchConductType === enums.ResearchTypes[1].code;
        },
    },
};
exports.enumHelper = enums.enumHelper, exports.HttpVerbs = enums.HttpVerbs, exports.Roles = enums.Roles;
exports.Countries = enums.Countries, exports.Environment = enums.Environment, exports.Ethnicities = enums.Ethnicities, exports.ProjectMatchingTriggerType = enums.ProjectMatchingTriggerType, exports.ParticipantType = enums.ParticipantType, exports.MarketingPricingPlanType = enums.MarketingPricingPlanType, exports.PricingCreditType = enums.PricingCreditType, exports.ParticipantAudienceType = enums.ParticipantAudienceType, exports.PricingChargeDetailType = enums.PricingChargeDetailType, exports.ResearchConductType = enums.ResearchConductType, exports.GenderType = enums.GenderType, exports.ProjectRecruitingStatus = enums.ProjectRecruitingStatus, exports.ResponseStatus = enums.ResponseStatus, exports.TaskStatus = enums.TaskStatus, exports.TaskParameters = enums.TaskParameters, exports.RespondentStatus = enums.RespondentStatus, exports.KindOfResearch = enums.KindOfResearch, exports.KindOfResearchTypes = enums.KindOfResearchTypes, exports.NdaType = enums.NdaType, exports.Verifications = enums.Verifications, exports.ProjectDisqualificationReason = enums.ProjectDisqualificationReason;
exports.default = enums;
